/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadinessStatus
 */
export interface ReadinessStatus {
    /**
     * 
     * @type {ReadinessStatusStatusEnum}
     * @memberof ReadinessStatus
     */
    status: ReadinessStatusStatusEnum;
}


/**
 * @export
 */
export const ReadinessStatusStatusEnum = {
    Ready: 'ready',
    NotReady: 'not_ready'
} as const;
export type ReadinessStatusStatusEnum = typeof ReadinessStatusStatusEnum[keyof typeof ReadinessStatusStatusEnum];


/**
 * Check if a given object implements the ReadinessStatus interface.
 */
export function instanceOfReadinessStatus(value: object): value is ReadinessStatus {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function ReadinessStatusFromJSON(json: any): ReadinessStatus {
    return ReadinessStatusFromJSONTyped(json, false);
}

export function ReadinessStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadinessStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
    };
}

export function ReadinessStatusToJSON(json: any): ReadinessStatus {
    return ReadinessStatusToJSONTyped(json, false);
}

export function ReadinessStatusToJSONTyped(value?: ReadinessStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
    };
}

